import { makeMutationForm } from 'components/makeMutationForm/makeMutationForm';
import { UpdateBankAccountCrudMutationVariables } from './UpdateBankAccountCRUD.generated';
import { validateMutationForm } from 'toolbox';
import { CreateBankAccountMutationVariables } from './CreateBankAccount.generated';

export const UpdateBankAccountForm = makeMutationForm<
  UpdateBankAccountCrudMutationVariables
>({
  config: {
    bank_id: {
      type: 'bank_id',
    },
    product_type: {
      type: 'bankAccountProductType',
    },
    opening_interest_rate: {
      type: 'number',
    },
    fixed_maturity_date: {
      type: 'date',
    },
    notice_days: {
      type: 'number',
    },
    account_id: {
      type: 'text',
    },
    currencyId: {
      type: 'hidden',
    },
  },
  validate: (values) => {
    if (!values.product_type) {
      return {
        product_type: errorStrings.noProductTypeProvidedOnAccount,
      };
    }
    if (values.product_type === 'FIXED' && !values.fixed_maturity_date) {
      return {
        fixed_maturity_date: errorStrings.noFixedMaturityDateOnAccount,
      };
    }
    if (values.product_type === 'NOTICE' && !values.notice_days) {
      return {
        notice_days: errorStrings.noNoticeDaysOnAccount,
      };
    }
    return validateMutationForm({
      values,
      config: {
        opening_interest_rate: ['mustBeNumber'],
      },
    });
  },
});

export const CreateBankAccountForm = makeMutationForm<
  CreateBankAccountMutationVariables & {
    // organisation_id: number;
    business_unit_id: number;
    currencyId: number;
  }
>({
  config: {
    bank_id: {
      type: 'bank_id',
    },
    organisation_id: {
      type: 'organisation_id',
    },
    currency_book_id: {
      type: 'select',
    },
    business_unit_id: {
      type: 'select',
    },
    currencyId: {
      type: 'hidden',
    },
    product_type: {
      type: 'bankAccountProductType',
    },
    account_description: {
      type: 'text',
    },
    opening_interest_rate: {
      type: 'number',
    },
    fixed_maturity_date: {
      type: 'date',
    },
    notice_days: {
      type: 'number',
    },
    account_id: {
      type: 'text',
    },
  },
  validate: (values) => {
    console.log({ values });
    if (!values.bank_id) {
      return { bank_id: errorStrings.noBankIdProvided };
    }
    if (!values.currency_book_id) {
      return { currency_book_id: errorStrings.noCurrencyBookIdProvided };
    }
    if (!values.currencyId) {
      return { currencyId: errorStrings.noCurrencyProvided };
    }
    if (!values.organisation_id) {
      return { organisation_id: errorStrings.noOrganisationIdProvided };
    }
    if (!values.business_unit_id) {
      return { business_unit_id: errorStrings.noBusinessUnitIdProvided };
    }
    if (!values.product_type) {
      return {
        product_type: errorStrings.noProductTypeProvidedOnAccount,
      };
    }
    if (values.product_type === 'FIXED' && !values.fixed_maturity_date) {
      return {
        fixed_maturity_date: errorStrings.noFixedMaturityDateOnAccount,
      };
    }
    if (values.product_type === 'NOTICE' && !values.notice_days) {
      return {
        notice_days: errorStrings.noNoticeDaysOnAccount,
      };
    }
    if (!values.account_description || !values.account_id) {
      return {
        account_description: errorStrings.noAccountId,
      };
    }
    return validateMutationForm({
      values,
      config: {
        opening_interest_rate: ['required', 'mustBeNumber'],
      },
    });
  },
});

export const errorStrings = {
  noAccountFoundForId: (id: string) =>
    `No bank accounts were found the ID given: ${id}. Provide a bank account ID which links to an account in our database.`,
  noAccountId: 'You must provide an Account Description and Account ID.',
  noBankIdProvided: 'You must provide a Bank ID.',
  noOrganisationIdProvided: 'You must specify a parent Organisation.',
  noBusinessUnitIdProvided: 'You must specify a parent Business Unit.',
  noCurrencyBookIdProvided: 'You must provide a parent Currency Book.',
  noCurrencyProvided: 'You must provide a Currency.',
  noOpeningInterestRate: 'You must specify an interest rate.',
  noProductTypeProvidedOnAccount: 'You must specify the account type.',
  invalidProductTypeOnAccount:
    'The account type must be either CALL, FIXED or NOTICE.',
  noFixedMaturityDateOnAccount:
    'You must provide a fixed maturity date on FIXED accounts.',
  noNoticeDaysOnAccount:
    'You must provide the amount of notice days given on a NOTICE account.',
};
